export default "__VITE_ASSET__D_i6kOQf__"